export const API_URL = `${process.env.NEXT_PUBLIC_LARAVEL_URL}/api`;
export const LARAVEL_URL = process.env.NEXT_PUBLIC_LARAVEL_URL;
export const GOOGLE_MAPS_KEY = "AIzaSyCbpk1kDH8nWslQuZ4qrPT9m29lSRwDm5c";
export const ASSET_PATH = process.env.NEXT_PUBLIC_S3_ASSET_PATH;
export const SEGMENT_WRITE_KEY = process.env.NEXT_SEGMENT_WRITE_KEY;
export const PROCESS = process.env.NODE_ENV;
export const GLOBAL_BUILDER_ID = 1;
export const DEPLOY_TIMESTAMP = process.env.NEXT_PUBLIC_DEPLOY_TIMESTAMP;
export const SHOW_DEV_INFO = process.env.NEXT_PUBLIC_SHOW_DEV_INFO;
export const SENTRY_ENV = process.env.NEXT_PUBLIC_SENTRY_ENV || "local";
